// extracted by mini-css-extract-plugin
module.exports = {"btnFilter":"Filter_btnFilter__27Vrr"};